'use es6';

import { useRenderElement } from "../internals/useRenderElement.js";
/**
 * Renders a Base UI element.
 *
 * @public
 */
export function useRender(params) {
  var _params$defaultTagNam;
  return useRenderElement((_params$defaultTagNam = params.defaultTagName) !== null && _params$defaultTagNam !== void 0 ? _params$defaultTagNam : 'div', params, params);
}